import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { SectionHeader } from '@factorialco/factorial-one-react/dist/experimental'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { EmployeeBenefitsList } from 'modules/benefits/pages/MyBenefits/MyBenefitsList/EmployeeBenefitsList'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const MyBenefitsListPage = () => {
  useEffect(() => {
    track(trackingEvents.benefits.openMyBenefitsListPage)
  }, [])

  return (
    <ResponsivePage.Body showHeader={false} variant="full">
      <SectionHeader
        title={i18n.t('benefits.my_benefits.my_benefits_list.title')}
        description={i18n.t('benefits.my_benefits.my_benefits_list.description')}
      />

      <Box paddingTop="s24" />

      <EmployeeBenefitsList />

      <Outlet />
    </ResponsivePage.Body>
  )
}

export default MyBenefitsListPage
